/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const resolveContextItemSearchText = item => {
  if (item?.searchText) {
    return item.searchText;
  }

  const parts = [item?.label, item?.id, item?.subtitle].filter(Boolean);

  return parts.join(' ');
};

export const resolveContextItemRowLabels = item => ({
  primary: item?.label ?? item?.id ?? item?.itemRef ?? '',
  secondary: item?.subtitle ?? '',
});
